function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Group 226"
}, React.createElement("path", {
  d: "M21.734 17.895L13.7 3.982a1.964 1.964 0 00-3.4 0L2.266 17.895a1.964 1.964 0 001.7 2.946h16.067a1.964 1.964 0 001.7-2.946zM12 18.578a1.278 1.278 0 111.278-1.278A1.28 1.28 0 0112 18.578zm1.287-5.465a1.287 1.287 0 11-2.574 0V7.206a.61.61 0 01.61-.61h1.355a.61.61 0 01.61.61v5.907z",
  fill: "#d25c64"
}), React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 206",
  fill: "none"
}));

var SvgWarningTriangle = function SvgWarningTriangle(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxkZWZzPgogICAgICAgIDxzdHlsZT4KICAgICAgICAgICAgLmNscy0xe2ZpbGw6I2QyNWM2NH0uY2xzLTJ7ZmlsbDpub25lfQogICAgICAgIDwvc3R5bGU+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iR3JvdXBfMjI2IiBkYXRhLW5hbWU9Ikdyb3VwIDIyNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyMTggLTM2NCkiPgogICAgICAgIDxwYXRoIGlkPSJhdHRlbnRpb24iIGQ9Ik0xOS43MzQgMjguMTcyTDExLjcgMTQuMjU5YTEuOTY0IDEuOTY0IDAgMCAwLTMuNCAwTC4yNjYgMjguMTcyYTEuOTY0IDEuOTY0IDAgMCAwIDEuNyAyLjk0NmgxNi4wNjdhMS45NjQgMS45NjQgMCAwIDAgMS43LTIuOTQ2ek0xMCAyOC44NTVhMS4yNzggMS4yNzggMCAxIDEgMS4yNzgtMS4yNzhBMS4yOCAxLjI4IDAgMCAxIDEwIDI4Ljg1NXptMS4yODctNS40NjVhMS4yODcgMS4yODcgMCAxIDEtMi41NzQgMHYtNS45MDdhLjYxLjYxIDAgMCAxIC42MS0uNjFoMS4zNTVhLjYxLjYxIDAgMCAxIC42MS42MXY1LjkwN3oiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIyMCAzNTMuNzIzKSIvPgogICAgICAgIDxwYXRoIGlkPSJSZWN0YW5nbGVfMjA2IiBkPSJNMCAwaDI0djI0SDB6IiBjbGFzcz0iY2xzLTIiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDIwNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIxOCAzNjQpIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgWarningTriangle as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/warning-triangle.svg
// module id = 785
// module chunks = 0